import { CircularProgress } from "@mui/material";

import styles from "@/styles/onboarding.module.scss";

export const Container = ({
  children,
  altMobileBg = false,
  onSubmit,
  formClass = "",
}) => {
  const bg = altMobileBg ? "bg-white md:bg-onmoLightGrey" : "bg-onmoLightGrey";
  return (
    <div className={bg}>
      <div className="max-w-1424 mx-auto px-5 md:px-24">
        <div className="flex justify-center py-10">
          <form
            className={`${formClass} flex flex-col gap-10`}
            onSubmit={onSubmit}
            autoComplete="off"
          >
            {children}
          </form>
        </div>
      </div>
    </div>
  );
};

export const Box = ({
  children,
  gap = 5,
  width = "small",
  hideBoxMobile = false,
  altMobileBg = false,
  className = "",
}) => {
  const altBg = altMobileBg ? "bg-white" : "bg-onmoLightGrey md:bg-white";
  const bg = hideBoxMobile
    ? `${altBg} p-0 md:p-10 drop-shadow-none md:shadow-md`
    : "bg-white px-5 py-10 md:p-10 shadow-md";
  const boxWidth =
    width === "xlarge"
      ? "lg:w-[1065px] md:w-[750px]"
      : width === "large"
        ? "md:w-[650px]"
        : width === "medium"
          ? "md:w-[505px]"
          : width === "alt"
            ? "md:w-[818px]"
            : "md:w-[483px]";
  // const boxWidth = width ? width : 483
  return (
    <div
      className={`${bg} mx-auto rounded-lg flex flex-col w-full ${boxWidth} gap-5 ${`md:gap-${gap}`} min-h-[255px] justify-center md:min-h-[346px] ${className}`}
    >
      {children}
    </div>
  );
};

export const Button = ({
  children,
  disabled = false,
  loading = false,
  onClick = () => {},
  altButton = false,
  altLoading = false,
  loaderTestId = "",
}) => {
  if (loading) {
    return (
      <div className="flex justify-center h-[55px] md:h-[52px]">
        <CircularProgress
          data-testid={loaderTestId}
          className="!text-onmoPrimary"
        />
      </div>
    );
  }
  if (altLoading) {
    return (
      <div
        onClick={onClick}
        disabled={disabled}
        className={styles.altLoadingButton}
      >
        {children}
        <div className="flex justify-center h-[23px] md:h-[23px]">
          <CircularProgress sx={{ color: "#fff" }} size={23} />
        </div>
      </div>
    );
  }
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={altButton ? styles.contractComplete : styles.nextButton}
    >
      {children}
    </button>
  );
};
